module.exports = __webpack_public_path__ + "assets/images/tfg_r.2ba29a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tfg_r.png
// module id = 769
// module chunks = 1